<form [formGroup]="priceForm" (ngSubmit)="onSubmit()">
    <ng-container formArrayName="pricedetail">
      <div *ngFor="let detail of pricedetail.controls; let i = index" [formGroup]="detail">

        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Title 1</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-title1' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title1" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Title 2</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-title2' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title2" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Title 3</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-title3' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title3" />
                </mat-form-field>
            </div>
        </div>


        <!-- <div fxLayout="row" fxLayoutGap="10">
            <div fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Starter Price Annualy</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-s-price-annualy' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="s_price_annualy" />
                </mat-form-field>
            </div>

            <div fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Profession Price Annualy</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-p-price-annualy' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="p_price_annualy" />
                </mat-form-field>
            </div>

            <div fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Advanced Price Annualy</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-a-price-annualy' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="a_price_annualy" />
                </mat-form-field>
            </div>
        </div>

            <div fxLayout="row" fxLayoutGap="10">
                <div fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Starter Price lifetime</mat-label>
                        <input [attr.guide]="'pricing-table5-inp-s-price-life' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="s_price_life" />
                    </mat-form-field>
                </div>
    
                <div fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Profession Price lifetime</mat-label>
                        <input [attr.guide]="'pricing-table5-inp-p-price-life' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="p_price_life" />
                        
                    </mat-form-field>
                </div>
    
                <div fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Advanced Price lifetime</mat-label>
                        <input [attr.guide]="'pricing-table5-inp-a-price-life' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="a_price_life" />
                    </mat-form-field>
                </div>
            </div>
-->
                    <!-- <div fxLayout="row" fxLayoutGap="10">
            <div fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Button name</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-s-button' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="s_button" />
                </mat-form-field>
            </div>

            <div fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Button link</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-p-button' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="p_button" />
                    
                </mat-form-field>
            </div>

            <div fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Background color</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-a-button' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="a_button" />
                </mat-form-field>
            </div>
         </div>                          -->
        
            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Silver help info</mat-label>
                        <input [attr.guide]="'pricing-table5-inp-s-charge-life' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="s_charge_life" />
                    </mat-form-field>
                </div>
    
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Gold help info</mat-label>
                        <input [attr.guide]="'pricing-table5-inp-p-charge-life' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="p_charge_life" />
                        
                    </mat-form-field>
                </div>
    
                <div fxFlex.xs="100" fxFlex="33">
                    <mat-form-field fxFlex>
                        <mat-label>Platinum help info</mat-label>
                        <input [attr.guide]="'pricing-table5-inp-a-charge-life' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="a_charge_life" />
                    </mat-form-field>
                </div>
            </div>
                <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
                    <div fxFlex.xs="100" fxFlex="33">
                        <mat-form-field fxFlex>
                            <mat-label>Silver terms</mat-label>
                            <input [attr.guide]="'pricing-table5-inp-s-charge-year' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                            [autocomplete]="'off'" matInput
                            formControlName="s_charge_year" />
                        </mat-form-field>
                    </div>
        
                    <div fxFlex.xs="100" fxFlex="33">
                        <mat-form-field fxFlex>
                            <mat-label>Gold terms</mat-label>
                            <input [attr.guide]="'pricing-table5-inp-p-charge-year' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                            [autocomplete]="'off'" matInput
                            formControlName="p_charge_year" />
                            
                        </mat-form-field>
                    </div>
        
                    <div fxFlex.xs="100" fxFlex="33">
                        <mat-form-field fxFlex>
                            <mat-label>Platinum terms</mat-label>
                            <input [attr.guide]="'pricing-table5-inp-a-charge-year' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                            [autocomplete]="'off'" matInput
                            formControlName="a_charge_year" />
                        </mat-form-field>
                    </div>
                </div>            

<!-- 
             <div fxFlex="10">
                <button [attr.guide]="'pricing-table5-btn-1' + '__' + sanitizedUrl" mat-raised-button color="warn" (click)="deletePricingDetail(i)">Delete</button>
            </div> -->
                               

 
         <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Silver Sub title</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-s-subtitle' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="s_subtitle" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Gold Sub title</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-p-subtitle' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="p_subtitle" />
                    
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Platinum Sub title</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-a-subtitle' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="a_subtitle" />
                </mat-form-field>
            </div>
         </div>                        


        <ng-container formArrayName="list_detail">
          <div fxLayout.xs="column" *ngFor="let item of detail.get('list_detail').controls; let j = index" [formGroup]="item" style="border: 1px solid lightgray;padding: 15px;margin: 5px;">
            <div  fxLayout="column" fxLayoutGap="10px" class="mobilewidth"  style="width: 30%;">
                <div >
                <mat-form-field fxFlex>
                    <mat-label>Category</mat-label>
                    <mat-select formControlName="types">
                        <mat-option *ngFor="let item of catType" [value]="item.value">
                          {{item.viewValue}}
                        </mat-option>
                      </mat-select>
                </mat-form-field>
                </div>                    
            </div>

                <div *ngIf="item.get('types').value == '2'" fxLayout="row" fxLayout.xs="column" fxLayoutGap="10px" style="width: 100%;">
                    <div class="mobilewidth" style="width: 20%;">
                    <mat-form-field fxFlex>
                    <mat-label>Sub Title</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-sub-title' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="sub_title" />
                </mat-form-field>
                    </div>
                    <div  class="mobilewidth" style="width: 20%;">
                <mat-form-field fxFlex>
                    <mat-label>Silver</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-starters' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="starters" />
                </mat-form-field>
                    </div>

                    <div class="mobilewidth" style="width: 20%;">                    
                <mat-form-field fxFlex>
                    <mat-label>Gold</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-professions' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="professions" />
                </mat-form-field>
                    </div>

                    <div class="mobilewidth" style="width: 20%;">
                <mat-form-field fxFlex>
                    <mat-label>Platinum</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-advanceds' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="advanceds" />
                </mat-form-field>
                    </div>
                    <div class="mobilewidth" style="width: 20%;">
                <mat-form-field fxFlex>
                    <mat-label>Mandatory</mat-label>
                    <mat-select formControlName="require">
                        <mat-option *ngFor="let item of mandatory" [value]="item.value">
                          {{item.viewValue}}
                        </mat-option>
                      </mat-select>
                </mat-form-field>

                </div>
            </div>
        

            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px" *ngIf="item.get('types').value == '1'">
                <calsoft-image fxFlex (deleteResult)="deletImageArray($event, i,'value',j)"
                (fileUploadResult)="
                updatesImageArray($event, i,'value',j)" [index]="j"
                [value]="item.value.value">
              </calsoft-image>
            </div>
                <!-- <mat-form-field fxFlex>
                    <mat-label>Additional</mat-label>
                    <input [attr.guide]="'pricing-table5-inp-advanceds' + '__' + sanitizedUrl" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="advanceds" />
                </mat-form-field> -->
                <div fxFlex>
                    <button [attr.guide]="'pricing-table5-btn-2' + '__' + sanitizedUrl" mat-raised-button color="warn" (click)="deleteListDetail(i, j)">Delete</button>
                </div>
            </div>

          
          <button [attr.guide]="'pricing-table5-btn-3' + '__' + sanitizedUrl" mat-raised-button (click)="addListDetail(i)">Add List</button>
        </ng-container><br/>

      </div><br/>
      <!-- <button [attr.guide]="'pricing-table5-btn-4' + '__' + sanitizedUrl" mat-raised-button (click)="addPricingDetails()">Add Pricing Detail</button> -->
    </ng-container><br/>
    <button [attr.guide]="'pricing-table5-btn-5' + '__' + sanitizedUrl" mat-raised-button color="primary" type="submit" style="margin-top: 10px;margin-bottom: 10px;" >{{btntext}}</button>
  </form>
